module.exports = __webpack_public_path__ + "img/thread.c3f676a4.svg";